import { tw } from "@careinfo/tailwind";
import { HTMLAttributes } from "react";
import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from "react-hook-form";

interface Props<T extends FieldValues>
  extends HTMLAttributes<HTMLInputElement> {
  control: Control<T>;
  name: FieldPath<T>;
  label?: string;
}

const CheckBox = <T extends FieldValues>({
  control,
  name,
  label,
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController<T>({
    name,
    control,
    defaultValue: null,
  });

  return (
    <div className={tw`flex items-center gap-x-4`}>
      <input
        {...field}
        type="checkbox"
        checked={field.value}
        className={tw` cursor-pointer`}
        id={field.name}
      />
      <label htmlFor={field.name} className={tw` cursor-pointer`}>
        {label}
      </label>
      {error && (
        <p className={tw`text-red-500 text-xs my-1`}>
          {JSON.stringify(error?.message)}
        </p>
      )}
    </div>
  );
};

export default CheckBox;
